// src/pages/Discount/DiscountPage.jsx
import React from 'react';
import Dis from './Components/Dis';

function DiscountPage() {
  return <Dis />;
}

export default DiscountPage;